import { Component, ElementRef, ViewChild } from '@angular/core';

import { ICellEditorAngularComp } from 'ag-grid-angular';
import { ValueFormatterParams } from 'ag-grid-community';

/**
 * numeric-cell
 */
@Component({
	template: `
		<input type="text" [(ngModel)]="value" decimalOnly="twoDigitDecimalNumber" #inputField style="width: 100%" />
	`
})
export class TwoDigitDecimalEditorComponent implements ICellEditorAngularComp {
	@ViewChild('inputField', { static: true }) inputField: ElementRef;
	public params: ValueFormatterParams;
	public value: number;

	public agInit(params: ValueFormatterParams): void {
		this.params = params;
		this.value = this.params.value;
		setTimeout(() => {
			this.inputField.nativeElement.focus();
			this.inputField.nativeElement.select();
		});
	}

	public getValue(): number {
		return this.value;
	}
}
